import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import LandingPage from "./pages/LandingPage";
import Class10Results2025 from "./pages/Class10Results2025";
import Class12Results2025 from "./pages/Class12Results2025";
import ResultSubmission from "./pages/ResultSubmission";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/results/class-12-2025" element={<Class12Results2025 />} />
          <Route path="/results/class-10-2025" element={<Class10Results2025 />} />
          <Route path="/submit-results" element={<ResultSubmission />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </div>
  );
}

export default App;
